import {Stack, styled} from '@mui/material';

export const DropZone = styled('label')<{$isDragging: boolean; $hasError: boolean}>`
	height: 521px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 12px;
	padding: 24px 16px;
	border: 1px dashed
		${({theme, $hasError}) =>
			$hasError ? theme.palette.error.main : theme.palette.primary.main};
	border-radius: 8px;
	background-color: ${({theme, $isDragging}) =>
		$isDragging
			? theme.colors.light.primary['08Percent']
			: theme.colors.light.background.paper};
	cursor: pointer;
	transition: background-color 0.15s ease;
`;

export const HiddenInput = styled('input')`
	display: none;
`;

export const FileRow = styled(Stack)`
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	gap: 8px;
	padding: 8px 12px;
	border: 1px solid ${({theme}) => theme.palette.other.outlineBorder};
	border-radius: 8px;
	background-color: ${({theme}) => theme.colors.light.background.paper};
`;

export const UploadedFileCard = styled(Stack)`
	width: 100%;
	padding: 16px;
	border-radius: 4px;
	border-bottom: 1px solid ${({theme}) => theme.palette.other.outlineBorder};
	background-color: ${({theme}) => theme.colors.light.background.paper};
	gap: 12px;
`;
